// url에 있는 파라미터 가져오기
const GetUrlParams = () => {
  var params = {};
  window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
    params[key] = value;
  });
  return params;
};

// 오늘 날짜 YYYY-MM-DD로 지정하는 함수
const GetFormatToday = () => {
  var d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
};

const pad = (number) => {
  if (number < 10) {
    return "0" + number;
  }
  return number;
};

const groupBy = function (data, key) {
  return data.reduce(function (carry, el) {
    var group = el[key];

    if (carry[group] === undefined) {
      carry[group] = [];
    }

    carry[group].push(el);
    return carry;
  }, {});
};

export { GetUrlParams, GetFormatToday, pad, groupBy };
